<template>
  <div class="main-carousel">
    <VueSlickCarousel ref="carousel" v-bind="settings">
      <a v-for="(slide, index) in slides" :key="index" :href="getUrl(slide)" :target="(slide.slide_type === 'URL') ? '_blank' : '_self'" @click="onClick(slide)">
        <picture class="slide-img">
          <source media="(min-width:768px)" :srcset="slide.image">
          <img :src="slide.image_mobile ? slide.image_mobile : slide.image">
        </picture>
      </a>
    </VueSlickCarousel>
    <div class="icon-list left" :class="{'touch-device': isTouchDevice}" @click="prev">
      <icon name="chevron-left" scale="2"></icon>
    </div>
    <div class="icon-list right" :class="{'touch-device': isTouchDevice}" @click="next">
      <icon name="chevron-right" scale="2"></icon>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
// import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  components: { VueSlickCarousel },
  props: {
    slides: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      settings: {
        dots: false,
        infinite: true,
        initialSlide: 0,
        slidesToShow: 1,
        swipeToSlide: true,
        arrows: false,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 4000
      }
    }
  },
  computed: {
    isTouchDevice () {
      return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0))
    }
  },
  methods: {
    getUrl (item) {
      let url = '#'
      if (item.category_id && item.slide_type === 'CAT') {
        url = `#/content/content-category/${item.category_id.pk}`
      } else if (item.element_id && item.slide_type === 'CON' && item.element_id.type === 'DIR') {
        url = `#/content/content-detail/${item.element_id.id}`
      } else if (item.element_id && item.slide_type === 'CON') {
        url = `#/content/content-detail/${item.element_id.id}`
      } else if (item.slide_type === 'URL') {
        url = item.url
      }
      return url
    },
    onClick (item) {
      const data = {
        key: 'clickSlider',
        segmentation: {}
      }
      if (item.category_id && item.slide_type === 'CAT') {
        data.segmentation = {
          id: item.category_id.pk,
          name: item.category_id.name,
          connect: 'CAT',
          url: this.getUrl(item)
        }
      } else if (item.element_id && item.slide_type === 'CON') {
        data.segmentation = {
          id: item.element_id.id,
          name: item.element_id.name,
          connect: 'CON',
          url: this.getUrl(item)
        }
      } else if (item.slide_type === 'URL') {
        data.segmentation = {
          id: '',
          name: '',
          connect: 'EXT',
          url: item.url
        }
      }

      window.Countly.q.push(['add_event', data])
    },
    next () { this.$refs.carousel.next() },
    prev () { this.$refs.carousel.prev() }
  }
}
</script>

<style scoped lang="scss">
.main-carousel {
  position: relative;
  &:hover .icon-list {
    opacity: 1;
  }

  .slide-img img{
    width: 100%;
    max-width: 100%;
    height: auto;
  }

  .icon-list {
    position: absolute;
    height: 100%;
    top: 0px;
    padding: 1rem;
    font-size: 4.5rem;
    line-height: 1;
    color: white;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    opacity: 0;

    // touch
    &.touch-device { display: none; }
    &.left { left: 0px; }
    &.right { right: 0px; }

    svg {
      filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .9));
      opacity: 0.5;

      &:hover { opacity: 1; }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main-carousel.vue